// Backend source of truth:
// serve-api/src/main/java/edu/liberty/serve/register/RegistrationController.java
// (SUCCESS_MESSAGE and BANNER_DOWN_MESSAGE).

export const REGISTER_MESSAGES = {
  SUCCESS: 'Registration successful.',
  BANNER_DOWN: 'Registration will be processed soon.',
} as const;

export enum RegistrationOutcome {
  SUCCESS = 'SUCCESS',
  BANNER_DOWN = 'BANNER_DOWN',
  ERROR = 'ERROR',
  UNKNOWN = 'UNKNOWN',
}

export function parseRegistrationOutcome(result?: string | null): RegistrationOutcome {
  if (!result) {
    return RegistrationOutcome.UNKNOWN;
  }

  const normalizedResult = result.trim();

  if (normalizedResult === REGISTER_MESSAGES.SUCCESS) {
    return RegistrationOutcome.SUCCESS;
  }

  if (normalizedResult === REGISTER_MESSAGES.BANNER_DOWN) {
    return RegistrationOutcome.BANNER_DOWN;
  }

  if (normalizedResult.startsWith('Error')) {
    return RegistrationOutcome.ERROR;
  }

  return RegistrationOutcome.UNKNOWN;
}
